import useBreakpoint, { Breakpoint } from './interface/useBreakpoint';

export const useCarousel = () => {
  const { lessThanBreakpoint } = useBreakpoint();

  const carouselSize = lessThanBreakpoint(Breakpoint.SM) ? 'sm' : 'md';

  return { carouselSize };
};
